import request from './request';
//let BaseUrl = 'http://192.168.11.242:10097/';
let BaseUrl = 'https://www.chinadentalshow.com/';

// 获取banner图
export function webMenu(params) {
    return request({
        url: BaseUrl + 'pc/WebMenu/lists',
        method: 'get',
        params
    })
}

// 获取新闻资讯列表
export function articleList(params) {
    return request({
        url: BaseUrl + 'pc/article/lists',
        method: 'get',
        params
    })
}

// 获取新闻资讯详情列表
export function articleDetail(params) {
    return request({
        url: BaseUrl + 'pc/article/detail',
        method: 'get',
        params
    })
}


// 获取网站基本信息
export function getWebsiteBase() {
    return request({
        url: BaseUrl + 'pc/WebSetting/getWebsiteBase',
        method: 'get'
    })
}

// 获取页面配置
export function getWebsite(params) {
    return request({
        url: BaseUrl + 'pc/WebSetting/getWebsite',
        method: 'get',
        params
    })
}

// 获取备案信息
export function getCopyright() {
    return request({
        url: BaseUrl + 'pc/WebSetting/getCopyright',
        method: 'get'
    })
}
// 收藏
// 公司:company ,活动：activity,产品：product  新闻：news，商机 business
export function public_collect(data) {
    return request({
        url: `/pc/public/collect`,
        method: 'post',
        data
    })
}

// 获取合作伙伴
export function getPartner() {
    return request({
        url: BaseUrl + 'pc/partner/partner',
        method: 'get'
    })
}

// 获取主要合作商
export function getMainPartner() {
    return request({
        url: BaseUrl + 'pc/partner/mainPartner',
        method: 'get'
    })
}

// 获取首页中部导航
export function WebNavigation() {
    return request({
        url: BaseUrl + 'pc/WebNavigation/lists',
        method: 'get'
    })
}

// 获取我们的展商
export function exhibitorPartner() {
    return request({
        url: BaseUrl + 'pc/partner/exhibitor',
        method: 'get'
    })
}

// 获取联系我们
export function contactsList() {
    return request({
        url: BaseUrl + 'pc/contacts/lists',
        method: 'get'
    })
}

// 获取下载中心列表
export function downloadCenter(params) {
    return request({
        url: BaseUrl + 'pc/DownloadCenter/lists',
        method: 'get',
        params
    })
}

// 获取字典
// 人员规模 staff_size_arr
// 企业性质 enterprise_nature_arr
// 企业经营类型 enterprise_type_arr
// 展位类型 booth_type
// 产品体系 product_structure
// 产品认证 product_authentication
// 产品标签 product_label
export function dict_lists(params) {
    return request({
        url:'/pc/dict/lists',
        method: 'get',
        params
    })
}


// 获取二级页面相关内容  
// 1:展会介绍
// 2:主办方
// 3:观众参展
// 4:住宿信息
// 5:到达场馆
// 6:口腔大会
// 7:展商参展
export function webAbout(params) {
    return request({
        url: BaseUrl + 'pc/webAbout/lists',
        method: 'get',
        params
    })
}

//获取参展类型 1:展商类型  2:观众类型
export function webExhibitionType(params) {
    return request({
        url: BaseUrl + 'pc/webExhibitionType/lists',
        method: 'get',
        params
    })
}

//获取轮播图
export function slideList(params) {
    return request({
        url: BaseUrl + 'pc/Slide/lists',
        method: 'get',
        params
    })
}


//获取活动列表
export function activityList(params) {
    return request({
        url: BaseUrl + 'pc/activity/lists',
        method: 'get',
        params
    })
}

//获取活动详情
export function pc_activity_detail(params) {
    return request({
        url: BaseUrl + '/pc/activity/detail',
        method: 'get',
        params
    })
}


//获取活动类型
export function ActivityCate() {
    return request({
        url: BaseUrl + 'pc/ActivityCate/lists',
        method: 'get',
    })
}

//发送验证码
export function sendCode(data) {
    return request({
        url: BaseUrl + 'pc/login/send_pcode',
        method: 'post',
        data
    })
}

//网站登录
export function login(data) {
    return request({
        url: BaseUrl + 'pc/login/logon',
        method: 'post',
        data
    })
}

//获取个人信息
export function userInfo() {
    return request({
        url: BaseUrl + 'pc/user/info',
        method: 'get',
    })
}


//退出登录
export function logout() {
    return request({
        url: BaseUrl + 'pc/login/logout',
        method: 'get',
    })
}


// 修改用户信息
export function updateInfo(data) {
    return request({
        url: BaseUrl + 'pc/user/updateInfo',
        method: 'put',
        data
    })
}

// 展商认证
export function companyAttestation(data) {
    return request({
        url: BaseUrl + 'pc/user/companyAttestation',
        method: 'put',
        data
    })
}

// 展商认证
export function uploadImage(data) {
    return request({
        url: BaseUrl + 'pc/Upload/image',
        method: 'POST',
        data
    })
}

// 获取隐私协议
export function getAgreement() {
    return request({
        url: BaseUrl + 'pc/WebSetting/getAgreement',
        method: 'get',
    })
}

// 获取收藏列表
export function collectList(params) {
    return request({
        url: BaseUrl + 'pc/public/collectList',
        method: 'get',
        params
    })
}


// 获取我的商机
export function publishList() {
    return request({
        url: BaseUrl + 'pc/business_publish/mylists',
        method: 'get'
    })
}

// 获取我的应答
export function replyList() {
    return request({
        url: BaseUrl + 'pc/business_reply/mylists',
        method: 'get'
    })
}

// 获取我的索样／我的留言
export function consultationList(params) {
    return request({
        url: BaseUrl + 'pc/MemberConsultation/lists',
        method: 'get',
        params
    })
}

// 获取亮点活动
export function getHighlightActivity() {
    return request({
        url: BaseUrl + 'pc/highlightActivityCategory/lists',
        method: 'get'
    })
}

// 获取精彩回顾
export function getHighlightReview() {
    return request({
        url: BaseUrl + 'pc/highlightReview/lists',
        method: 'get'
    })
}




